module.exports = __webpack_public_path__ + "img/31b6392.svg";